import styled from 'styled-components';

const Heading = styled.h2`
  font-family: ${(p) => p.theme.secondFont};
  font-size: 26px;
  color: ${(p) => p.theme.headingColor};
  font-weight: bold;
  margin: 0;
`;

export default Heading;
